import branchManagementCashDeliveriesComponent from './cash_deliveries.component';

let branchManagementCashDeliveriesModule = angular.module('branchManagementCashDeliveries', [])
  .component('branchManagementCashDeliveries', branchManagementCashDeliveriesComponent)
  .name;

export default branchManagementCashDeliveriesModule;


// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/cash_deliveries/index.js